import {Pipe, PipeTransform} from '@angular/core';
import {
    REPORTING_DATETIME_FORMAT,
    ReportingDatePreset,
    ReportingDateTimeService,
} from './reporting-datetime.service';

/**
 * Organization reporting-TZ aware date pipe.
 *
 * Usage:
 *   {{ value | reportingDate }}
 *   {{ value | reportingDate:'date' }}
 *   {{ value | reportingDate:'dd-MM-yyyy HH:mm' }}
 */
@Pipe({
    name: 'reportingDate',
    standalone: true,
    pure: true,
})
export class ReportingDatePipe implements PipeTransform {
    constructor(private reportingDateTime: ReportingDateTimeService) {
    }

    transform(
        value: string | number | Date | null | undefined,
        formatOrPreset: string | ReportingDatePreset = 'datetime',
    ): string {
        if (
            formatOrPreset === 'datetime'
            || formatOrPreset === 'date'
            || formatOrPreset === 'time'
            || formatOrPreset === 'apiDate'
        ) {
            return this.reportingDateTime.formatPreset(value, formatOrPreset);
        }
        return this.reportingDateTime.format(value, formatOrPreset || REPORTING_DATETIME_FORMAT);
    }
}
